module.exports = __webpack_public_path__ + "static/img/20200518-4.f3bfbf0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/20200518-4.png
// module id = oD8h
// module chunks = 1